import { create } from 'zustand';
import _ from 'lodash';
interface initDataState {
  param: any;
  bindParam: any;
  result: any;
  initPayload: any;
  payload: any;
  bind: (result: { data: any }) => void;
  bindPayload: (payload: { data: any }) => void;
}

// 주택 자금저축
export const initPensionPayload = {
  acct_year: '', //연말정산   년도
  co_cd: '', //회사코드
  co_id: '', //사번
  in_data_seqid: 0, //입력데이터 sequence
  data_type: '', //
  htx_amt: 0, //금액(국세청)
  amt: 0, //금액(일반)
  bank_cd: '', //은행코드
  account_num: '', //계좌번호
  is_htx_pdf: 'N', //국세청사용여부
  is_private_school: '', //관리자 사학연금 업로드 여부
};

export const initParam = {
  // currentNum: 1,
  // viewCount: 10,
  keyword: '',
  sortField: 'doc_seq',
  sortType: 'desc',
  initialSeq: 0,
};

/**
  개인연금,연금계좌
**/
export const pensionDataStore = create<initDataState>(set => ({
  param: { ...initParam },
  bindParam: (bind: any) =>
    set(state => ({
      ...state,
      param: { ...state.param, ...bind },
    })),
  result: [],
  bind: (data: any) =>
    set(state => ({
      ...state,
      result: { ...state.result, ...data },
    })),
  initPayload: initPensionPayload,
  payload: _.cloneDeep(initPensionPayload),
  bindPayload: (data: any) =>
    set(state => ({
      ...state,
      payload: { ...state.payload, ...data },
    })),
}));
